<script setup lang="ts">
  const title = ref('Admin Portal')
  const description = ref('Administrate Your Resources')
  const { data } = useSession();
  const signEmail = data?.value?.user?.email || 'notsignedin'
  // This will be reactive when you change title/description above
  useHead({
    title,
    meta: [{
      name: 'description',
      content: description
    }],
})
</script>
<template>
  <div>
    <NuxtLayout>
      <ErrorSnackbar />
      <NuxtLoadingIndicator color="#ebc334"/>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
